import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-1 mb-xl-1" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-6 mt-6\" style=\"padding-left:30px;\"><h3 class=\"fw-bolder m-0\"><span class=\"card-label fw-bolder fs-3 mb-1\">Dokumen PKS</span></h3><h3 class=\"fw-bolder m-0\"><span class=\"text-muted mt-1 fw-bold fs-7\">Manajemen Data Sekolah </span></h3></div>", 1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor PKS", -1)
const _hoisted_13 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-6 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tanggal Mulai", -1)
const _hoisted_18 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tanggal Selesai", -1)
const _hoisted_22 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-6 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Status", -1)
const _hoisted_27 = ["label", "value"]
const _hoisted_28 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "col-lg-6 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Note", -1)
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-6 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Perbarui dokumen PKS", -1)
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 col-form-label fw-bold fs-6" }, "Perpanjang Otomatis PKS", -1)
const _hoisted_41 = { class: "form-check pb-2" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Tidak ", -1)
const _hoisted_44 = { class: "form-check pb-2" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Ya ", -1)
const _hoisted_47 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_48 = { style: {"display":"inline-flex","margin-left":"30px"} }
const _hoisted_49 = {
  class: "form-check pb-2",
  style: {"margin-right":"10px"}
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios21"
}, " 1 Tahun ", -1)
const _hoisted_52 = {
  class: "form-check pb-2 mr-1",
  style: {"margin-right":"10px"}
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios23"
}, " 3 Tahun ", -1)
const _hoisted_55 = {
  class: "form-check pb-2 mr-1",
  style: {"margin-right":"10px"}
}
const _hoisted_56 = ["disabled"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios25"
}, " 5 Tahun ", -1)
const _hoisted_58 = { style: {"display":"inline-flex","margin-left":"30px"} }
const _hoisted_59 = {
  class: "form-check pb-2 mr-1",
  style: {"margin-right":"10px"}
}
const _hoisted_60 = ["disabled"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios22"
}, " 2 Tahun ", -1)
const _hoisted_62 = {
  class: "form-check pb-2 mr-1",
  style: {"margin-right":"10px"}
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios24"
}, " 4 Tahun ", -1)
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-5\" style=\"padding-left:5px;\"><h3 class=\"fw-bolder mt-8\"><span class=\"card-label fw-bolder fs-3\">Informasi Tambahan</span></h3><h3 class=\"fw-bolder\"><span class=\"text-muted mt-1 fw-bold fs-7\">Manajemen Data Sekolah </span></h3></div>", 1)
const _hoisted_66 = { class: "card-body border-top p-9" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-6 fv-row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Bank", -1)
const _hoisted_70 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_71 = { class: "col-lg-6 fv-row" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Admin Top Up", -1)
const _hoisted_73 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_74 = { class: "row mb-6" }
const _hoisted_75 = { class: "col-lg-6 fv-row" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Alamat Email", -1)
const _hoisted_77 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_78 = { class: "col-lg-6 fv-row" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon Sekolah", -1)
const _hoisted_80 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_81 = { class: "d-flex justify-content-end py-8 px-9" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, {
                type: "text",
                name: "responsiblePerson",
                class: "form-control form-control-lg",
                placeholder: "Isi Nama Sekolah",
                modelValue: _ctx.editDetail.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editDetail.name) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              (_ctx.editDetail.name == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.items.errorNamaSekolah), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Field, {
                type: "text",
                name: "number",
                class: "form-control form-control-lg",
                placeholder: "Isi Nomor PKS",
                modelValue: _ctx.editDetail.number,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editDetail.number) = $event)),
                disabled: _ctx.items.disableother
              }, null, 8, ["modelValue", "disabled"]),
              (_ctx.editDetail.number == '' || _ctx.editDetail.number == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.items.errorNomorPks), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_Field, {
                type: "date",
                name: "startDate",
                class: "form-control form-control-lg",
                placeholder: "Isi Tanggal Mulai",
                modelValue: _ctx.editDetail.startDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editDetail.startDate) = $event)),
                disabled: _ctx.items.disableother
              }, null, 8, ["modelValue", "disabled"]),
              (_ctx.editDetail.startDate == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.items.errorStartDate), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_Field, {
                type: "date",
                name: "expiredDate",
                class: "form-control form-control-lg",
                placeholder: "Isi Tanggal Selesai",
                modelValue: _ctx.editDetail.expiredDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editDetail.expiredDate) = $event)),
                disabled: _ctx.items.disableother
              }, null, 8, ["modelValue", "disabled"]),
              (_ctx.editDetail.expiredDate == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.items.errorEndDate), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                as: "select",
                class: "form-select form-select-lg fw-bold",
                name: "status",
                modelValue: _ctx.editDetail.status,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editDetail.status) = $event)),
                disabled: _ctx.items.disableother
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listStatus, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option,
                      label: _ctx.changeBahasa(option),
                      value: option
                    }, null, 8, _hoisted_27))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]),
              (_ctx.editDetail.status == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.items.errorStatus), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                name: "note",
                class: "form-control form-control-lg",
                placeholder: "Isi Note",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editDetail.note) = $event)),
                disabled: _ctx.items.disablenote
              }, null, 8, _hoisted_32), [
                [_vModelText, _ctx.editDetail.note]
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_ErrorMessage, { name: "note" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              (_openBlock(), _createElementBlock("input", {
                name: "file",
                type: "file",
                id: "file",
                class: "form-control form-control-lg",
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleFileUpload($event))),
                key: _ctx.items.fileInputKey,
                disabled: _ctx.items.disableother
              }, null, 40, _hoisted_38))
            ]),
            (_ctx.items.showExtendPKS == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: _ctx.items.disableother,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editDetail.auto_renewal) = $event)),
                      class: "form-check-input",
                      type: "radio",
                      name: "exampleRadios",
                      id: "exampleRadios1",
                      value: "false"
                    }, null, 8, _hoisted_42), [
                      [_vModelRadio, _ctx.editDetail.auto_renewal]
                    ]),
                    _hoisted_43
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: _ctx.items.disableother,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editDetail.auto_renewal) = $event)),
                      class: "form-check-input",
                      type: "radio",
                      name: "exampleRadios",
                      id: "exampleRadios2",
                      value: "true"
                    }, null, 8, _hoisted_45), [
                      [_vModelRadio, _ctx.editDetail.auto_renewal]
                    ]),
                    _hoisted_46
                  ]),
                  (
                _ctx.editDetail.auto_renewal == 'true' ||
                _ctx.editDetail.auto_renewal == true
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: _ctx.items.disableother,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editDetail.renewal_in_days) = $event)),
                                class: "form-check-input",
                                type: "radio",
                                name: "exampleRadios1",
                                id: "exampleRadios21",
                                value: "365"
                              }, null, 8, _hoisted_50), [
                                [_vModelRadio, _ctx.editDetail.renewal_in_days]
                              ]),
                              _hoisted_51
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: _ctx.items.disableother,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editDetail.renewal_in_days) = $event)),
                                class: "form-check-input",
                                type: "radio",
                                name: "exampleRadios1",
                                id: "exampleRadios23",
                                value: "1095"
                              }, null, 8, _hoisted_53), [
                                [_vModelRadio, _ctx.editDetail.renewal_in_days]
                              ]),
                              _hoisted_54
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: _ctx.items.disableother,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editDetail.renewal_in_days) = $event)),
                                class: "form-check-input",
                                type: "radio",
                                name: "exampleRadios1",
                                id: "exampleRadios25",
                                value: "1825"
                              }, null, 8, _hoisted_56), [
                                [_vModelRadio, _ctx.editDetail.renewal_in_days]
                              ]),
                              _hoisted_57
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: _ctx.items.disableother,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editDetail.renewal_in_days) = $event)),
                                class: "form-check-input",
                                type: "radio",
                                name: "exampleRadios1",
                                id: "exampleRadios22",
                                value: "730"
                              }, null, 8, _hoisted_60), [
                                [_vModelRadio, _ctx.editDetail.renewal_in_days]
                              ]),
                              _hoisted_61
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: _ctx.items.disableother,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editDetail.renewal_in_days) = $event)),
                                class: "form-check-input",
                                type: "radio",
                                name: "exampleRadios1",
                                id: "exampleRadios24",
                                value: "1460"
                              }, null, 8, _hoisted_63), [
                                [_vModelRadio, _ctx.editDetail.renewal_in_days]
                              ]),
                              _hoisted_64
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_65
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createVNode(_component_Field, {
                type: "text",
                name: "responsiblePerson",
                class: "form-control form-control-lg",
                placeholder: "",
                modelValue: _ctx.editDetail.listBankName,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editDetail.listBankName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              (_ctx.editDetail.listBankName == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createVNode(_component_Field, {
                type: "text",
                name: "responsiblePerson",
                class: "form-control form-control-lg",
                modelValue: _ctx.editDetail.topupFee,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editDetail.topupFee) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              (_ctx.editDetail.topupFee == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_73))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode(_component_Field, {
                type: "text",
                name: "responsiblePerson",
                class: "form-control form-control-lg",
                placeholder: "",
                modelValue: _ctx.editDetail.schoolEmail,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editDetail.schoolEmail) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              (_ctx.editDetail.schoolEmail == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_77))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createVNode(_component_Field, {
                type: "text",
                name: "responsiblePerson",
                class: "form-control form-control-lg",
                modelValue: _ctx.editDetail.schoolPhone,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editDetail.schoolPhone) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              (_ctx.editDetail.schoolPhone == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("button", {
            class: "btn btn-danger me-3",
            type: "cancel",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.push('/superadmin/legal/legalitas/')))
          }, " Batal "),
          _createElementVNode("button", {
            id: "kt_account_profile_details_submit",
            class: "btn btn-primary",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveChanges1 && _ctx.saveChanges1(...args)))
          }, _hoisted_84)
        ])
      ])
    ])
  ], 64))
}